(() => {
  const videoSelector = '[data-aotf-hero-video]';

  const initializeVideo = (video) => {
    if (video.dataset.aotfHeroVideoReady === 'true') return;

    const media = video.closest('.aotf3-hero__media');
    const playButton = media?.querySelector('[data-aotf-video-play]');
    const playIcon = playButton?.querySelector('[data-aotf-video-icon]');
    const playLabel = playButton?.querySelector('[data-aotf-video-label]');
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const narrowScreen = window.matchMedia('(max-width: 989px)');
    const connection = navigator.connection;
    const deferAutomaticVideo = () => reducedMotion?.matches || narrowScreen.matches || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    let userRequestedPlayback = false;
    const loadVideoSource = () => {
      const source = video.querySelector('source[data-src]');
      if (source && !source.hasAttribute('src')) {
        source.src = source.dataset.src;
        video.load();
      }
    };

    const setPlaybackProperties = () => {
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    };

    const updatePlaybackControl = (isPlaying) => {
      if (!playButton || media?.classList.contains('has-video-error')) return;

      if (isPlaying) {
        playButton.hidden = true;
        media?.classList.remove('is-video-blocked');
        return;
      }

      playButton.hidden = false;
      playButton.setAttribute('aria-label', 'Play the river video');
      if (playIcon) playIcon.textContent = '▶';
      if (playLabel) playLabel.textContent = 'Play river video';
      media?.classList.add('is-video-blocked');
    };

    const attemptPlayback = (fromUser = false) => {
      if (fromUser) {
        userRequestedPlayback = true;
        video.classList.add('is-user-playing');
      }

      if (!fromUser && deferAutomaticVideo() && !userRequestedPlayback) {
        video.pause();
        updatePlaybackControl(false);
        return;
      }

      loadVideoSource();
      setPlaybackProperties();
      const playAttempt = video.play();

      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(() => updatePlaybackControl(true)).catch(() => updatePlaybackControl(false));
      } else {
        window.setTimeout(() => {
          updatePlaybackControl(!video.paused);
        }, 250);
      }
    };

    playButton?.addEventListener('click', () => attemptPlayback(true));
    video.addEventListener('playing', () => updatePlaybackControl(true));
    video.addEventListener('pause', () => updatePlaybackControl(false));
    video.addEventListener('canplay', () => attemptPlayback());
    video.addEventListener('loadeddata', () => attemptPlayback());
    video.addEventListener('error', () => {
      media?.classList.add('has-video-error');
      if (playButton) playButton.hidden = true;
    });
    video.addEventListener('aotf:resume', () => attemptPlayback());

    const handleMotionPreference = (event) => {
      if (event.matches && !userRequestedPlayback) {
        video.pause();
        updatePlaybackControl(false);
      } else {
        attemptPlayback();
      }
    };

    if (typeof reducedMotion?.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleMotionPreference);
    } else if (typeof reducedMotion?.addListener === 'function') {
      reducedMotion.addListener(handleMotionPreference);
    }

    video.dataset.aotfHeroVideoReady = 'true';
    setPlaybackProperties();

    if (deferAutomaticVideo()) {
      updatePlaybackControl(false);
    } else {
      const startAfterPageLoad = () => window.setTimeout(() => attemptPlayback(), 1200);
      if (document.readyState === 'complete') startAfterPageLoad();
      else window.addEventListener('load', startAfterPageLoad, { once: true });
    }

    window.setTimeout(() => {
      if (!media?.classList.contains('has-video-error')) updatePlaybackControl(!video.paused);
    }, 1800);
  };

  const initialize = (root = document) => {
    if (root.matches?.(videoSelector)) initializeVideo(root);
    root.querySelectorAll?.(videoSelector).forEach(initializeVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    document.querySelectorAll(videoSelector).forEach((video) => {
      video.dispatchEvent(new Event('aotf:resume'));
    });
  });
})();
